import { memo } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import { getSelectedTenantsForContentSharing } from '@tabeeb/modules/appConfigState/selectors'
import { selectTenantDestination } from '@tabeeb/modules/contentSharings/actions'
import { getContentSharingDialogState } from '@tabeeb/modules/contentSharings/selectors'
import { Select } from '@collaborate-health/uikit'
import { FormControl, MenuItem } from '@mui/material'

interface TenantDestinationProps {
  isDisabled: boolean
}

const TenantDestination: React.FC<TenantDestinationProps> = ({ isDisabled }) => {
  const dispatch = useDispatch()
  const tenantsList = useSelector(getSelectedTenantsForContentSharing)
  const { tenant } = useSelector(getContentSharingDialogState)

  const _handleChange = (e) => {
    const tenantName = e.target.value
    const selectedTenant = tenantsList.find((t) => t.Name === tenantName)

    if (tenant?.Id !== selectedTenant?.Id) {
      dispatch(selectTenantDestination(selectedTenant))
    }
  }

  return (
    <FormControl fullWidth>
      <Select value={tenant?.Name || ''} onChange={_handleChange} disableUnderline disabled={isDisabled}>
        {tenantsList &&
          tenantsList.map((t) => (
            <MenuItem key={t.Id} value={t.Name}>
              {t.Name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  )
}

export default memo(TenantDestination)

